import { DateTime as DT } from 'luxon';
import type { TaskType } from '@econtractor/types';
import { TaskTypeStatus } from '@econtractor/types';
import { getObjectCardPath } from 'utils/helpers/objects/objectCardPath';

export const isOverdueTask = (task: TaskType): boolean => {
    if (Number(task.taskDeleted)) return false;
    const status = Number(task.taskStatus);
    const closed =
        status === TaskTypeStatus.COMPLETED ||
        status === TaskTypeStatus.ACCEPTED ||
        status === TaskTypeStatus.CANCELLED ||
        status === TaskTypeStatus.REJECT;
    if (closed) return false;
    const end = Number(task.dateEnd || 0);
    return end > 0 && end < Date.now();
};

export const formatDue = (task: TaskType): string | null => {
    const end = Number(task.dateEnd || 0);
    if (!end) return null;
    const dt = DT.fromMillis(end, { zone: 'local' });
    if (!dt.isValid) return null;
    return task.withTime ? dt.toFormat('dd.MM.yy HH:mm') : dt.toFormat('dd.MM.yy');
};

export const getRelatedLabel = (
    task: TaskType,
): {
    icon: string;
    label: string;
    title: string;
    to: string;
    leadId: number | null;
    objectId: number | null;
} | null => {
    if (task.objectInfo?.ID) {
        const name = String(task.objectInfo.objectName || '').trim() || `#${task.objectInfo.ID}`;
        const isService = Number(task.objectInfo.onlyService) === 1;
        const isSale = Number(task.objectInfo.onlySale) === 1 && !isService;
        return {
            icon: isService ? 'toolbox' : isSale ? 'cash-coin' : 'sunrise',
            label: name,
            title: name,
            to: getObjectCardPath(
                task.objectInfo.ID,
                task.objectInfo.onlySale,
                task.objectInfo.onlyService,
            ),
            leadId: null,
            objectId: task.objectInfo.ID,
        };
    }
    if (task.leadInfo?.ID) {
        const name = String(task.leadInfo.clientName || '').trim() || `#${task.leadInfo.ID}`;
        return {
            icon: 'card-checklist',
            label: name,
            title: name,
            to: `/leads/${task.leadInfo.ID}`,
            leadId: task.leadInfo.ID,
            objectId: null,
        };
    }
    return null;
};
